export const ROUTES = [
  {
    title: 'Activity Feed',
    to: '/coach/activity-feed'
  },
  {
    title: 'Users',
    to: '/coach/user-management'
  },
  {
    title: 'Workshops',
    to: '/coach/workshops'
  },
  {
    title: 'Resource Library',
    to: '/coach/resource-library'
  }
]
